import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    // Send page_view event
    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href,
      page_path: location.pathname,

      // Debug on localhost only
      debug_mode: window.location.hostname === "localhost",
    });
  }, [location]);

  return null; // No UI
}
